/**
 * @fileoverview Org portal — the Settings hub (/org/settings). One row per
 * section in lib/orgSettings.js, each a link to that section's own page, in
 * four groups (iOS review C10): You, Organization, Scheduling and History.
 *
 * Links rather than buttons, so a section can be opened in a new tab like any
 * other page in the portal. The frame and breadcrumb come from
 * OrgSettingsLayout.
 */

import { Link } from "react-router-dom";
import { Card, Icon, SectionHeader } from "@/components/studio/primitives";
import { orgSettingsGroups } from "@/lib/orgSettings";

export default function OrgSettingsPage() {
  return (
    <div data-testid="org-settings-page">
      <h1 className="mb-2 font-serif text-2xl font-semibold text-[var(--text-primary)]">Settings</h1>
      <p className="mb-6 font-sans text-[13px] text-[var(--text-tertiary)]">
        Your organization&apos;s plan, the people who run it, and how it appears to instructors and families.
      </p>

      {orgSettingsGroups().map((group) => (
        <section key={group.id} className="mb-6" data-testid={`org-settings-group-${group.id}`}>
          <SectionHeader>{group.label}</SectionHeader>
          <Card padding={0}>
            {group.sections.map((s, i) => (
              <Link
                key={s.id}
                to={s.path}
                data-testid={`org-settings-${s.id}`}
                className={[
                  "flex items-center gap-[14px] px-[18px] py-[14px] transition-colors duration-150 hover:bg-[var(--studio-overlay)]",
                  i === 0 ? "rounded-t-[20px]" : "",
                  i === group.sections.length - 1 ? "rounded-b-[20px]" : "border-b border-[var(--studio-divider)]",
                ].join(" ")}
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[12px] bg-[var(--studio-interactive)]">
                  <Icon name={s.icon} size={18} className="text-[var(--text-secondary)]" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="font-sans text-base font-medium text-[var(--text-primary)]">{s.label}</div>
                  <div className="mt-0.5 font-sans text-[13px] text-[var(--text-tertiary)]">{s.desc}</div>
                </div>
                <Icon name="chevronRight" size={18} className="text-[var(--text-tertiary)]" />
              </Link>
            ))}
          </Card>
        </section>
      ))}
    </div>
  );
}
